import * as config from "../config.js";
import { getIDToken } from "./utils";

export const checkTokenValidity = async () => {
  const token = getIDToken();
  if (!token) {
    return false;
  }

  const response = await fetch(
    `${config.REST_SERVER_URL}/auth/check-token/${token}`,
    {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    }
  );
  const data = await response.json();

  return data.valid;
};
